<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-market`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.714 4H29.286C28.023 4 27 4.943 27 6.105V15h-9.714C16.023 15 15 15.927 15 17.071V25H5.286C4.023 25 3 25.773 3 26.727v15.546C3 43.227 4.023 44 5.286 44h11.428c.102 0 .201-.005.299-.015.09.01.18.015.273.015h11.428c.097 0 .193-.005.287-.016.093.01.188.016.285.016h11.428C41.977 44 43 43.057 43 41.895V6.105C43 4.943 41.977 4 40.714 4zM27 40V19h-8v21h8zm4 0h8V8h-8v32zm-16 1V29H7v12h8z"/></svg>
</template>
<script>

export default {
  name: 'IconMarket',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
